<!-- 首页 -->
<template>
  <div class=''>
    <HeadView :title="headTitle"
              :content="headContent"
              :imgPath="headImgPath"
              @btnClick="linkKefu"
              :btnText="headBtnText" />
    <div class="gg--wrap">
      <span class="iconfont icon-gonggao"
            style="margin-left:360px;"></span>
      <span style="margin-left:4px">公告</span>
      <div class="gg__divide--s"></div>
      <span class="gg__tip"
            v-if="announceItem.type">{{ announceItem.type }}</span>
      <span class="gg__title"
            @click="toDetail(announceItem.id)">{{ announceItem.title }}</span>
      <span style="flex-grow:1;"></span>
      <span class="gg__date">{{ announceItem.time }}</span>
      <div class="gg__divide--s"></div>
      <span class="gg__more"
            @click="toMore">查看更多</span>
      <span class="iconfont icon-jiantou-you"
            style="margin-right:360px;margin-left:4px;"></span>
    </div>
    <div class="reason__title"
         style="">为什么选择我们？</div>
    <div class="reason--wrap">
      <div class="reason__item">
        <img src="../../images/xjdjs.png"
             alt=""
             class="reason__item__img">
        <span class="reason__item__title">先进的技术</span>
        <div class="reason__item__content">确保客户的电子认证申请和验证过程安全、快速、准确</div>
      </div>
      <div class="reason__item reason__item--no1">
        <img src="../../images/rzfwdz.png"
             alt=""
             class="reason__item__img">
        <span class="reason__item__title">多种认证的服务</span>
        <div class="reason__item__content">为客户提供多种认证服务,包括个人、企业、机构等类型的认证,满足客户不同的需求</div>
      </div>
      <div class="reason__item reason__item--no1">
        <img src="../../images/aqkk.png"
             alt=""
             class="reason__item__img">
        <span class="reason__item__title">安全可靠</span>
        <div class="reason__item__content">严格遵守相关法律法规；与客户保持良好的沟通,及时反馈认证进度,确保客户能够及时享受认证服务。</div>
      </div>
    </div>

    <div class="domain-c">
      <div class="domain__title"
           style="">应用领域</div>
      <div class=" domain--wrap">
        <div class="domain__item">
          <img src="../../images/min_zw.png"
               alt=""
               class="domain__item__img">
          <span class="domain__item__title">政务</span>

        </div>
        <div class="domain__item domain__item--no1">
          <img src="../../images/min_qy.png"
               alt=""
               class="domain__item__img">
          <span class="domain__item__title">企业</span>

        </div>
        <div class="domain__item domain__item--no1">
          <img src="../../images/min_other.png"
               alt=""
               class="domain__item__img">
          <span class="domain__item__title">其他</span>

        </div>

      </div>

    </div>

    <div class="contact--wrap">
      <div class="contact__content--wrap">
        <div class="contact__phone__title--wrap">
          <div class="iconfont icon-fuwurexian img"></div>
          <span>服务热线</span>
        </div>
        <span class="contact__phone__content">{{ phone }}</span>
        <div class="line"></div>
        <div class="contact__phone__title--wrap">
          <div class="iconfont icon-QQ img"></div>
          <span>QQ咨询</span>
        </div>
        <span class="contact__phone__content">{{ qq }}</span>
      </div>
      <div class="contact__title--wrap">
        <transition name="contactTitleAnim">
          <div class="contact__title"
               v-show="showContactTitle">
            <div class="iconfont icon-lianxiwomen img"></div>
            <div class="title-content ">联系我们</div>
          </div>
        </transition>
        <div class="contact__jiantou">
          <div class="iconfont icon-shouqi img"></div>
        </div>

      </div>

    </div>
    <div class="partner--wrap">
      <div class="partner__title--wrap">
        <div class="line"></div>
        <div class="partner__title">合作伙伴</div>
        <div class="line"></div>
      </div>
      <div class="partner__content--wrap">
        <div class="partner__content__item--wrap"
             v-for="(item,index) in partnerData"
             :key="index">
          <img :src="item.img"
               class="partner__content__item__img"
               alt="">
          <span class="partner__content__item__title">{{ item.title }}</span>
        </div>
      </div>
    </div>
    <foot-view></foot-view>

  </div>
</template>

<script>
import HeadView from '@/components/Head/Head.vue'

export default {
  name: 'HomeView',

  components: { HeadView },
  data () {
    return {
      announceItem: {
        id: 1,

        time: '2023-07-27',
        title: '关于“浪微澜科技（广州）有限公司”发票业务暂停通知。',
        url: 'http://www.baidu.com',
        type: 'new'
      },
      phone: '020-26232815',
      qq: '360766954',
      headTitle: '电子认证服务',
      headContent: '浪微澜科技（广州）有限公司为数安时代科技股份有限公司（广东CA）认证业务服务商，负责广州区域粤政通数字证书项目发行、售前服务及推广并对用户身份进行线下身份核验业务，致力于为客户提供高效、安全、可靠的电子认证服务。',
      headImgPath: require('../../images/dzrzfw.png'),
      headBtnText: '立即咨询',
      showContactTitle: true,
      partnerData: [
        { img: require('../../images/gdca_logo.png'), title: '数安时代科技股份有限公司' },
        { img: require('../../images/dljz_logo.png'), title: '广州市代理记账协会' }]
    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {
    linkKefu () {
      window.open('https://w102.ttkefu.com/k/linkurl/?t=2E4EIF5')
    },
    toDetail (id) {
      this.$router.push({ name: 'announceDetail', params: { item: 'announcementView', announceId: Number(id) } }, () => { })
    },
    toMore () {
      this.$router.push({ name: 'about', params: { item: 'announcementView' } }, () => { })
    }
  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.gg--wrap {
  min-width: 1500px;
  display: flex;
  align-items: center;
  height: 64px;
  background: #f5f9ff;
  font-size: 14px;
  margin-top: 1px;
  .gg__divide--s {
    height: 32px;
    width: 1px;
    background-color: #dbe0ee;
    margin: 0 24px;
  }
  .gg__tip {
    display: inline-block;
    background: rgba(255, 0, 13, 0.1);
    padding: 2px 8px;
    border-radius: 2px;
    color: #ff000d;
  }
  .gg__title {
    margin-left: 8px;
    max-width: 400px;
    overflow: scroll;
    max-lines: 1;
    &:hover {
      cursor: pointer;
      user-select: none;
      color: $color-primary;
    }
  }
  .gg__date {
    color: #999999;
  }
  .gg__more {
    color: #333333;
    &:hover {
      cursor: pointer;
      user-select: none;
      color: $color-primary;
    }
  }
}
.reason__title {
  text-align: center;
  margin: 100px 0 60px 0;
  font-weight: 500;
  font-size: 32px;
}
.reason--wrap {
  width: 100%;
  display: flex;
  justify-content: center;

  .reason__item {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 384px;
    height: 402px;
    opacity: 1;
    border-radius: 8px;
    background: #f5f9ff;
    position: relative;
    &:hover {
      cursor: pointer;
      .reason__item__img {
        width: 188px;
        height: 188px;
        animation-name: size-change;
        animation-duration: 0.1s;
        animation-timing-function: linear;
      }
      .reason__item__title {
        color: #3269ff;
      }
    }
    .reason__item__img {
      width: 164px;
      height: 164px;
      margin-top: 56px;
      animation-name: size-change-r;
      animation-duration: 0.1s;
      animation-timing-function: linear;
    }
    .reason__item__title {
      font-size: 24px;
      margin-top: 24px;
      font-weight: bold;
      color: #333333;
      position: absolute;
      top: 244px;
    }
    .reason__item__content {
      color: #999;
      font-size: 14px;
      margin: 16px 32px;
      position: absolute;
      top: 294px;
    }
  }
  .reason__item--no1 {
    margin-left: 24px;
  }
}
.domain-c {
  background-image: url("../../images/bg2.png");
  background-size: cover;
  background-repeat: no-repeat;
  height: 480px;
  padding-top: 100px;
  box-sizing: border-box;
  margin-top: 110px;
  .domain__title {
    text-align: center;
    margin: 0px 0 64px 0px;
    font-weight: 500;
    font-size: 32px;
  }
  .domain--wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    .domain__item {
      display: flex;
      flex-direction: column;
      align-items: center;

      width: 240px;
      height: 159px;
      opacity: 1;
      border-radius: 8px;
      background: #f5f9ff;
      position: relative;
      opacity: 1;
      background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);

      border: 1px solid #ffffff;

      &:hover {
        cursor: pointer;
        .domain__item__img {
          width: 56px;
          height: 56px;
          margin-top: 28px;
          animation-name: d-size-change;
          animation-duration: 0.1s;
          animation-timing-function: linear;
        }
        .domain__item__title {
          color: #3269ff;
        }
      }
      .domain__item__img {
        width: 48px;
        height: 48px;
        margin-top: 32px;
        animation-name: d-size-change-r;
        animation-duration: 0.1s;
        animation-timing-function: linear;
      }
      .domain__item__title {
        font-size: 24px;
        margin-top: 12px;
        font-weight: bold;
        color: #333333;
      }
    }
    .domain__item--no1 {
      margin-left: 24px;
    }
  }
}
.contact--wrap {
  right: 10px;
  bottom: 100px;
  position: fixed;

  // background-color: #3269ff;
  display: flex;

  .contact__content--wrap {
    width: 240px;
    height: 184px;
    padding: 24px;
    opacity: 1;
    border-radius: 8px;
    background: #f7f8fa;
    box-sizing: border-box;
    &::after {
      content: "";
      position: absolute;
      left: 240px;
      top: 80px;
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid #f7f8fa;
      border-right: transparent;
      transform: rotate(0deg);
    }
    &:hover {
      animation: contact-title-show;
    }
    .contact__phone__title--wrap {
      display: flex;
      align-items: center;

      .img {
        font-size: 24px;
        color: $color-primary;
        margin-right: 8px;
      }
      span {
        font-size: 16px;
      }
    }
    .contact__phone__content {
      color: $color-primary;
      margin-top: 4px;
      font-size: 16px;
      margin-left: 34px;
    }
    .line {
      height: 1px;
      background-color: rgba(0, 0, 0, 0.06);
      width: 192px;
      margin: 16px 0px;
    }
  }
  .contact__title--wrap {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    .contact__title {
      width: 44px;
      height: 124px;
      opacity: 1;
      border-radius: 22px;
      background: #f7f8fa;
      margin-bottom: 10px;

      border: 1px solid #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .img {
        font-size: 20px;
        color: $color-primary;
        margin-top: 16px;
      }
      .title-content {
        max-width: 14px;
        color: $color-primary;
        font-size: 14px;
        line-height: 17px;

        margin-top: 4px;
        margin-bottom: 16px;
      }
    }
    .contact__jiantou {
      width: 44px;
      height: 44px;
      opacity: 1;
      border-radius: 22px;
      background: #f7f8fa;
      display: flex;
      justify-content: center;
      align-items: center;

      border: 1px solid #ffffff;
      .img {
        font-size: 28px;
        color: #333;
      }
    }
  }
}
.partner--wrap {
  margin-top: 100px;
  padding: 0 360px;
  margin-bottom: 123px;
  .partner__title--wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    .partner__title {
      text-wrap: nowrap;
      width: 300px;
      font-size: 32px;
      font-weight: bold;
      margin: 0 24px;
    }
    .line {
      flex-grow: 1;
      height: 1px;
      background: rgba(0, 0, 0, 0.08);
    }
  }
  .partner__content--wrap {
    margin-top: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    :not(:first-child) {
      margin-left: 90px;
    }
    .partner__content__item--wrap {
      display: flex;
      align-items: center;

      .partner__content__item__title {
        margin-left: 26px;
      }
    }
  }
}

@-webkit-keyframes size-change {
  0% {
    width: 164px;
    height: 164px;
  }

  100% {
    width: 188px;
    height: 188px;
  }
}
@-webkit-keyframes size-change-r {
  100% {
    width: 164px;
    height: 164px;
  }

  0% {
    width: 188px;
    height: 188px;
  }
}
@keyframes size-change {
  0% {
    width: 164px;
    height: 164px;
  }

  100% {
    width: 188px;
    height: 188px;
  }
}
@keyframes size-change-r {
  100% {
    width: 164px;
    height: 164px;
  }

  0% {
    width: 188px;
    height: 188px;
  }
}

@keyframes d-size-change {
  0% {
    width: 48px;
    height: 48px;
    margin-top: 32px;
  }

  100% {
    width: 56px;
    height: 56px;
    margin-top: 28px;
  }
}
@keyframes d-size-change-r {
  100% {
    width: 48px;
    height: 48px;
    margin-top: 32px;
  }

  0% {
    width: 56px;
    height: 56px;
    margin-top: 28px;
  }
}
@keyframes contact-title-show {
  0% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
}
@keyframes contact-title-hidden {
  0% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0);
  }
}
@keyframes contact-content-show {
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
}
@keyframes contact-content-hidden {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}
</style>
